import { h, Component } from "preact";
import $ from "jquery";
import Header from '../components/header';

export default class Err404 extends Component {
  constructor(props) {
    super(props);
  }
	
  componentDidMount() {
   
  }

  render() {
    return (<>
      <Header title="Error" backurl="/" />
      <section class="menu">
        <div class="card card-style">
					<div class="content m-3 text-center">
           <h1>404</h1>
          </div>
       </div>
      </section>
    </>);
  }
}